import { createEvent, restore, sample } from 'effector'
import { CreateExchanger } from './types'
import { fx } from '../../../libs'
import { getClients } from '../../clients/list/model'
import { Error } from '../../gateway/edit/types'

export const clientDataMounted = createEvent<{ id: string }>()

export const setExchanger = createEvent<CreateExchanger>()

export const setExchangerError = createEvent<Error>()

export const setClientOption = createEvent<{ value: string; id: string }[]>()

export const submitCreateExchanger = createEvent<CreateExchanger>()
export const $exchanger = restore(setExchanger, {
  active: false,
  ownerId: 0,
  name: '',
  internalName: '',
  frontName: '',
  type: '',
  created: false,
})

export const $errorExchanger = restore(setExchangerError, {
  message: '',
  code: 0,
})

export const $clientOptions = restore(setClientOption, [
  {
    id: '',
    value: '',
  },
])

export const createExchanger = fx<CreateExchanger, void>({
  method: 'POST',
  url: '/exchanger',
})

sample({
  clock: submitCreateExchanger,
  fn: (exchanger) => {
    return {
      url: `/exchanger`,
      body: { ...exchanger },
    }
  },
  target: createExchanger,
})

sample({
  clock: clientDataMounted,
  fn: ({ id }) => {
    let query = {}

    // @ts-ignore
    query['where'] = `{"verified": true, "id": "like${id}"}`
    // @ts-ignore
    query['populate'] = '["Client.list"]'

    return {
      query,
    }
  },
  target: getClients,
})

sample({
  clock: getClients.doneData,
  fn: (doneData) => {
    const clients = doneData.body.items

    return clients.map((item) => ({
      id: item.clientId,
      value: item.fullName + ' (' + item.clientId + ')',
    }))
  },
  target: setClientOption,
})

sample({
  clock: createExchanger.doneData,
  fn: (_) => {
    return {
      active: false,
      ownerId: 0,
      name: '',
      internalName: '',
      frontName: '',
      type: '',
      created: true,
    }
  },
  target: setExchanger,
})

sample({
  clock: createExchanger.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setExchangerError],
})
